(function () {
  var FORM_CLASS = 'sq-drawer-search';
  function build() {
    var form = document.createElement('form');
    form.className = FORM_CLASS;
    form.setAttribute('action', (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'search');
    form.setAttribute('method', 'get');
    form.setAttribute('role', 'search');
    form.innerHTML =
      '<input type="hidden" name="options[prefix]" value="last">' +
      '<input class="sq-drawer-search__input" type="search" name="q" placeholder="Buscar squishies" aria-label="Buscar squishies" autocomplete="off" enterkeyhint="search">' +
      '<button class="sq-drawer-search__btn" type="submit" aria-label="Buscar">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>' +
      '</button>';
    return form;
  }
  function ensure() {
    document.querySelectorAll('header-drawer .menu-drawer__navigation').forEach(function (nav) {
      if (nav.parentNode && !nav.parentNode.querySelector('.' + FORM_CLASS)) {
        nav.parentNode.insertBefore(build(), nav);
      }
    });
  }
  function init() {
    ensure();
    new MutationObserver(ensure).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
